module.exports = __webpack_public_path__ + "static/media/yellow-star.297e4512.gif";